<template>
  <v-navigation-drawer
    persistent
    :temporary="permanent ? false : true"
    :mini-variant="false"
    :clipped="false"
    v-model="drawer"
    enable-resize-watcher
    fixed
    app
    right
  >
    <div>
      <v-list subheader two-line>
        <v-tooltip>
          <v-subheader
            slot="activator"
          >{{$route.name == 'email' ? 'Sub-Contractor Options' :'Filters and Settings'}}</v-subheader>
          <span>
            {{$route.name == 'email' ?
            'Here you can quickly add Sub-Contractors who have worked on projects or sites in selected billing periods' :
            'These settings filter the data that is returned from the server. This data can be sorted through from the filters on the main page.'}}
          </span>
        </v-tooltip>

        <v-list-tile v-if="model == null || model == 'contractor'">
          <v-list-tile-action>
            <v-icon>{{$store.state.global.pages.contractor.icon}}</v-icon>
          </v-list-tile-action>
          <v-autocomplete
            label="Contractor"
            color="indigo"
            :items="contractors"
            item-text="name"
            item-value="id"
            v-model="contractorId"
            :loading="loadingContractors"
            clearable
            @click:clear="() => $nextTick(() => contractorId = null, subjectId = null)"
          ></v-autocomplete>
        </v-list-tile>
        <v-list-tile v-if="model == null || model == 'vehicle'">
          <v-list-tile-action>
            <v-icon>{{$store.state.global.pages.vehicle.icon}}</v-icon>
          </v-list-tile-action>
          <v-autocomplete
            label="Vehicle"
            color="indigo"
            :items="vehicles"
            item-text="name"
            item-value="id"
            v-model="vehicleId"
            :loading="loadingVehicles"
            clearable
            @click:clear="() => $nextTick(() => vehicleId = null, subjectId = null)"
          ></v-autocomplete>
        </v-list-tile>

        <v-list-tile v-if="model == null || model == 'driver'">
          <v-list-tile-action>
            <v-icon>{{$store.state.global.pages.driver.icon}}</v-icon>
          </v-list-tile-action>
          <v-autocomplete
            label="Driver"
            color="indigo"
            :items="drivers"
            item-text="name"
            item-value="id"
            v-model="driverId"
            clearable
            @click:clear="() => $nextTick(() => driverId = null, subjectId = null)"
          ></v-autocomplete>
        </v-list-tile>
        <template>
          <v-subheader>Resource Type</v-subheader>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>{{$store.state.global.pages.contractor.icon}}</v-icon>
            </v-list-tile-action>
            <v-autocomplete
              label="Type"
              color="indigo"
              :items="resourceTypes"
              item-text="text"
              item-value="value"
              v-model="resourceType"
              :loading="loadingContractors"
              clearable
              @click:clear="() => $nextTick(() => resourceType = null)"
            ></v-autocomplete>
          </v-list-tile>
        </template>

        <template>
          <v-subheader>Date Range</v-subheader>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
            <date-picker-wrapper
              label="Start"
              noIcon
              style="width: 100%"
              v-model="dateRangeStart"
              :rules="[]"
            ></date-picker-wrapper>
          </v-list-tile>

          <v-list-tile v-if="!useSingleDate">
            <v-list-tile-action>
              <v-icon>date_range</v-icon>
            </v-list-tile-action>
            <date-picker-wrapper
              label="End"
              noIcon
              style="width: 100%"
              v-model="dateRangeEnd"
              :rules="[]"
            ></date-picker-wrapper>
          </v-list-tile>

          <v-list-tile @click="emptyFunc">
            <v-list-tile-action>
              <v-switch :color="$store.state.global.pages.docket.color" v-model="useSingleDate"></v-switch>
            </v-list-tile-action>
            <v-list-tile-content @click="toggleSingleDate">
              <v-list-tile-title class="body-2">Single Date</v-list-tile-title>
              <v-list-tile-sub-title>{{useSingleDate ? 'Yes!' : 'No'}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import BillingPeriods from '@/services/mixins/billingPeriods'
import RouteProps from '@/services/mixins/routeProps'
import getContractors from '@/services/mixins/getMasterFiles/getContractors'
import getVehicles from '@/services/mixins/getMasterFiles/getVehicles'
import getDrivers from '@/services/mixins/getMasterFiles/getDrivers'
import models from './mixins/models'
import DatePickerWrapper from '@/components/ui/datePickerWrapper'
export default {
  mixins: [RouteProps, getContractors, getVehicles, getDrivers, models],
  components: {
    DatePickerWrapper
  },
  data() {
    return {
      advancedSearchDialog: false
    }
  },
  methods: {
    emptyFunc() {
      return
    },
    toggleSingleDate() {
      this.useSingleDate = !this.useSingleDate
      this.dateRangeEnd = null
    }
  },
  computed: {
    drawer: Store.getSet({ store: 'compliance', prop: 'drawer' }),
    compliances: Store.getSet({ store: 'compliance', prop: 'compliances' }),
    contractorId: Store.getSet({ store: 'compliance', prop: 'contractorId' }),
    vehicleId: Store.getSet({ store: 'compliance', prop: 'vehicleId' }),
    driverId: Store.getSet({ store: 'compliance', prop: 'driverId' }),
    subjectId: Store.getSet({ store: 'compliance', prop: 'subjectId' }),
    dateRangeStart: Store.getSet({
      store: 'compliance',
      prop: 'dateRangeStart'
    }),
    dateRangeEnd: Store.getSet({ store: 'compliance', prop: 'dateRangeEnd' }),
    model: Store.getSet({ store: 'compliance', prop: 'model' }),
    resourceType: Store.getSet({ store: 'compliance', prop: 'resourceType' }),
    resourceTypes: Store.getSet({ store: 'compliance', prop: 'resourceTypes' }),
    useSingleDate: Store.getSet({ store: 'shared', prop: 'useSingleDate' })
  },
  watch: {
    useSingleDate(val) {
      if (val) {
        this.dateRangeEnd = this.dateRangeStart
      }
    },
    dateRangeStart(val) {
      if (this.useSingleDate) {
        this.dateRangeEnd = val
      }
    }
  },
  props: {
    permanent: Boolean
  }
}
</script>

<style>
.overlap-fab {
  position: absolute !important;
  bottom: -33px;
  right: 20px;
}
</style>
